module.exports = __webpack_public_path__ + "media/images/icons/icons_small/5_plane-07208dbdb60c385777f1ac1519914121.png";